import FuseUtils from "@fuse/utils";
import FuseLoading from "@fuse/core/FuseLoading";
import { Navigate } from "react-router-dom";
import settingsConfig from "app/configs/settingsConfig";
import SignInConfig from "../main/sign-in/SignInConfig";
import SignUpConfig from "../main/sign-up/SignUpConfig";
import SignOutConfig from "../main/sign-out/SignOutConfig";
import Error404Page from "../main/404/Error404Page";
import ExampleConfig from "../main/example/ExampleConfig";
import UsersListConfig from "../main/users/UsersListConfig";
import EmployeeConfig from "../main/employee-information/EmployeeConfig";
import CountryListConfig from "../main/countries/CountryListConfig";
import CityConfig from "../main/cities/CityConfig";
import ContainerTypeConfig from "../main/container-type/ContainerTypeConfig";
import TerritoriesConfig from "../main/territories/TerritoriesConfig";
import CustomersListConfig from "../main/customers/CustomersListConfig";
import ShowroomConfig from "../main/showroom/ShowroomConfig";
import PortsConfig from "../main/ports/PortsConfig";
import Redirect from "../auth/Redirect";
import RegionConfig from "../main/regions/RegionConfig";
import FactoryVendorConfig from "../main/factory-vendor/FactoryVenderConfig";
import MaterialMasterConfig from "../main/material-master/MaterialMasterConfig";
import OrderCategoryConfig from "../main/order-categorys/OrderCategoryConfig";
import ShippingTypeConfig from "../main/shipping-type/ShippingTypeCogfig";
import PriceGroupConfig from "../main/price-group/PriceGroupConfig";
import SalesBudgetConfig from "../main/sales-budget/SalesBudgetConfig";
import CalendarConfig from "../main/calendar/CalendarConfig";
import MarketingBudgetConfig from "../main/marketing-budget/MarketingBudgetConfig";
import DiscountMasterConfig from "../main/discount-master/DiscountMasterConfig";
import RoleConfig from "../main/role/RoleConfig";
import ChartOfAccountsConfig from "../main/finance/chart-of-accounts/ChartOfAccountsConfig";
import FinancialYearConfig from "../main/finance/financial-year/FinancialYearConfig";
import PaymentTermsConfig from "../main/finance/payment-terms/PaymentTermsConfig";
import DailyExchangeRateConfig from "../main/daily-exchange-rate/DailyExchangeRateConfig";
import OkrPerformanceConfig from "../main/OKR-performance/OkrPerformanceConfig";
import AttendanceConfig from "../main/attendance/AttendanceConfig";
import AssetConfig from "../main/assets/AssetConfig";
import AssetTypeConfig from "../main/asset-types/AssetTypeCofig";
import DashboardConfig from "../main/design-studio/dashboard/DashboardConfig";
import EurostatComparisonConfig from "../main/eurostat-comparison/EurostatComparisonConfig";
import HrPoliciesConfig from "../main/hr-policies/HrPoliciesConfig";
import AttendanceManagementConfig from "../main/attendance-management/AttendanceManagementConfig";
import DesignStudioListConfig from "../main/design-studio/DesignStudioListConfig";
import LogisticConfig from "../main/logistics/LogisticConfig";
import VoucherConfig from "../main/voucher/VoucherConfig";
import LeaveManagementConfig from "../main/leave-management/LeaveManagementConfig";
import ForwarderInfoConfig from "../main/logistics/forwarder-info/ForwarderInfoConfig";
import OrderConfig from "../main/order/OrderConfig";
import ProformaInvoiceConfig from "../main/proforma-invoice/ProformaInvoiceConfig";
import LetterOfCreditConfig from "../main/letter-of-credit/LetterOfCreditConfig";
import FinanceInvoiceConfig from "../main/finance-invoice/FinanceInvoiceConfig";
import SalesInvoiceConfig from "../main/sales-invoice/SalesInvoiceConfig";
import TrainingDashboardConfig from "../main/Training/training-dashboard/TrainingDashboardConfig";
import TrainersConfig from "../main/Training/Trainers/TrainersConfig";
import AttendeesListConfig from "../main/Training/attendees-list/AttendeesListConfig";
import TrainingCourseConfig from "../main/Training/training-course-list/TrainingCourseConfig";
import PurchaseInvoiceConfig from "../main/purchase-invoice/PurchaseInvoiceConfig";
import ContainerPlanningConfig from "../main/container-planning/ContainerPlanningConfig";
import BankConfig from "../main/bank/BankConfig";
import UsanceConfig from "../main/usanse/UsanceConfig";
import CommonDashboardConfig from "../main/dashboard/CommonDashboardConfig";
import DashboardPublicConfig from "../main/dashboard/DashboardPublicConfig";
import SpecialDiscountConfig from "../main/special-discount/SpecialDiscountConfig";
import DeliveryTermsConfig from "../main/delivery-terms/DeliveryTermsConfig";
import ExpenseClaimConfig from "../main/finance/expense-claim/ExpenseClaimConfig";
import PayrollConfig from "../main/finance/payroll/PayrollConfig";
import StatementOfAccountsConfig from "../main/finance/statement-of-accounts/StatementOfAccountConfig";
import TrialBalanceConfig from "../main/finance/trial-balance/TrialBalanceConfig";
import SalesForeCastConfig from "../main/sales-forecast/SalesForeCastConfig";
import RetailForecastConfig from '../main/sales-forecast/retail-forecast/RetailForecastConfig';
import ReconciliationConfig from "../main/reconcilitation/ReconciliationConfig";
import NominalLedgerConfig from "../main/finance/nominal-ledger/NominalLedgerConfig";
import ReportsConfig from "../main/reports/ReportsConfig";
import ForecastSalesReportConfig from '../main/sales-forecast/report/forecast-sales-report/ForecastSalesReportConfig'
import YtdAnalysisReportConfig from '../main/sales-forecast/report/ytdAnalysis/YtdAnalysisReportConfig';
import ProjectForecastConfig from '../main/sales-forecast/project/project-forecast/ProjectForecastConfig';
import ProjectPipelineConfig from '../main/sales-forecast/project/project-pipeline/ProjectPipelineConfig';
import DiscountApprovalConfig from "../main/sales-forecast/project/discount-approvals/DiscountApprovalConfig";
import SalesDashboardConfig from "../main/sales-forecast/project/dashboard/DashboardConfig";
import AoReasonConfig from "../main/ao-reason/AoReasonConfig";

const routeConfigs = [
  ContainerPlanningConfig,
  SpecialDiscountConfig,
  OrderConfig,
  DashboardConfig,
  UsersListConfig,
  HrPoliciesConfig,
  ChartOfAccountsConfig,
  FinancialYearConfig,
  StatementOfAccountsConfig,
  TrialBalanceConfig,
  PaymentTermsConfig,
  EmployeeConfig,
  AttendanceConfig,
  AttendanceManagementConfig,
  AssetConfig,
  AssetTypeConfig,
  EurostatComparisonConfig,
  DailyExchangeRateConfig,
  OkrPerformanceConfig,
  ExampleConfig,
  SignOutConfig,
  SignInConfig,
  SignUpConfig,
  TerritoriesConfig,
  CustomersListConfig,
  ShowroomConfig,
  PortsConfig,
  OrderCategoryConfig,
  ContainerTypeConfig,
  CountryListConfig,
  RegionConfig,
  CityConfig,
  FactoryVendorConfig,
  ShippingTypeConfig,
  PriceGroupConfig,
  SalesBudgetConfig,
  CalendarConfig,
  MaterialMasterConfig,
  MarketingBudgetConfig,
  DiscountMasterConfig,
  RoleConfig,
  DesignStudioListConfig,
  LogisticConfig,
  ForwarderInfoConfig,
  VoucherConfig,
  ProformaInvoiceConfig,
  LetterOfCreditConfig,
  BankConfig,
  UsanceConfig,
  FinanceInvoiceConfig,
  SalesInvoiceConfig,
  PurchaseInvoiceConfig,
  CommonDashboardConfig,
  DashboardPublicConfig,
  DeliveryTermsConfig,
  ExpenseClaimConfig,
  PayrollConfig,
  SalesForeCastConfig,
  RetailForecastConfig,
  ProjectForecastConfig,
  ProjectPipelineConfig,
  DiscountApprovalConfig,
  SalesDashboardConfig,
  TrainingDashboardConfig,
  TrainersConfig,
  TrainingCourseConfig,
  LeaveManagementConfig,
  ReconciliationConfig,
  NominalLedgerConfig,
  ReportsConfig,
  ForecastSalesReportConfig,
  YtdAnalysisReportConfig,
  AoReasonConfig,
];

const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
  {
    path: "/",
    element: <Navigate to="/redirect" />,
  },
  {
    path: "/authorized",
    element: <Redirect />,
  },
  {
    path: "/redirect",
    element: <Redirect />,
  },
  {
    path: "loading",
    element: <FuseLoading />,
  },
  {
    path: "404",
    element: <Error404Page />,
  },
  {
    path: "*",
    element: <Navigate to="404" />,
  },
];

export default routes;